import {Component, HostListener, OnInit} from '@angular/core';
import {IframeNotificationService} from './service/iframe-notification.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent  {

  iframe: boolean = true;

  @HostListener('window:resize')
  onResize() {
    this.iframeNotificationService.sendHeightEvent();
  }

  constructor(private iframeNotificationService: IframeNotificationService,
              private route: ActivatedRoute) {
    this.route.queryParamMap.subscribe(params => {
      this.iframe = params.get('iframe') !== 'false';
    });
  }
}
